import { StrictMode } from "react"
import { createRoot, type Root } from "react-dom/client"
import { App } from "./App"
import { ConfigError, LoadingScreen } from "./components/AuthScreens"
import { initSupabase } from "./config/supabaseClient"
import { ConfigUnavailable, fetchPublicConfig } from "./config/runtimeConfig"
import "./styles/global.scss"

/**
 * Bootstrap ASÍNCRONO: la config del browser (URL de Supabase + anon key) llega en
 * runtime de GET /api/config, no bakeada en el build. El por qué está en
 * config/runtimeConfig.ts — resumen: bakear forkearía SUPABASE_URL en una segunda
 * variable, y si alguna vez apuntan a proyectos distintos el login funciona y después
 * todas las llamadas dan 401 sin nada en los logs que lo explique.
 *
 *   1. fetch('/api/config')
 *   2. initSupabase(cfg)     ← ANTES del primer render: getSupabase() no puede fallar
 *   3. render(<App/>)
 *
 * Si (1) falla se renderiza <ConfigError/> con reintento, NUNCA una pantalla en blanco.
 */
const container = document.getElementById("root")
if (!container) throw new Error("Falta #root en index.html")

const root: Root = createRoot(container)

async function boot(): Promise<void> {
  root.render(<LoadingScreen />)
  try {
    const cfg = await fetchPublicConfig()
    initSupabase(cfg)
    root.render(
      <StrictMode>
        <App config={cfg} />
      </StrictMode>
    )
  } catch (err) {
    const message =
      err instanceof ConfigUnavailable
        ? err.message
        : "No se pudo cargar la configuración del tablero."
    root.render(<ConfigError message={message} onRetry={() => void boot()} />)
  }
}

void boot()
